import React from "react";

import type { NormalisedImage } from "@app/scripts/types";

type Props = {
  media: NormalisedImage;
};

export const MediaImage: React.FC<Props> = ({ media }) => (
  <img
    src={media.src + "&width=360"}
    data-src={media.src}
    data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"
    data-aspectratio={media.height / media.width}
    data-sizes="auto"
  />
);
